import React from 'react';

export type BelowMapTabProps = React.HTMLProps<HTMLDivElement> & {
  children: React.ReactNode | React.ReactNode[];
  tabName: React.ReactNode;
  contextKey: string;
  tabOrder?: number;
  activeTab?: boolean;
  unmountOnBlur?: boolean;
  to?: string;
  onTabFocus?: () => void;
  onTabBlur?: () => void;
};

export const BelowMapTab: React.FC<BelowMapTabProps> = ({
  children,
  tabName: _tabName,
  contextKey: _contextKey,
  tabOrder: _tabOrder,
  activeTab: _activeTab,
  unmountOnBlur: _unmountOnBlur,
  onTabBlur: _onTabBlur,
  onTabFocus: _onTabFocus,
  ...props
}) => {
  return (
    <div {...props} className={`h-100 ${props.className}`}>
      {children}
    </div>
  );
};
